// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"3573ba4a528184c1b605","655":"dce1d8043ea1031946e5"}[chunkId] + ".js";
};